import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const ExternalTransmissionPolicyPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">外部送信ポリシー</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              IVA株式会社（以下「当社」といいます。）では、当社が「DONDON」のサービス名で提供する全てのウェブサイト、ソフトウェア、アプリケーション、プロダクト、ドキュメントその他一切の製品及びサービスを提供するにあたって、これをお客様の利用する端末（パソコンやスマートフォンなど）を通じて、広告掲載やアクセス解析等の目的で、Cookieをはじめとしたタグや情報収集モジュールを用いて、お客様に関する情報（以下「利用者情報」といいます。）の外部送信を行っています。
              <br/><br/>
              利用者情報の送信先、外部送信において送信されることとなる、利用者情報の内容及び利用目的は以下をご覧ください。
            </div>
          </div>
          
          <div className="w-full flex flex-col justify-start items-start gap-[30px]">
            <div className="w-full flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">事業者：Google LLC及びその関係会社</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                <span>・サービス名：Google Analytics<br/>・送信される利用者情報<br/></span>
                <div className='ml-6'>
                  <span>・インターネット通信に通常用いられるシステム、デバイス、ネットワーク、通信に関する情報<br/>・位置情報<br/>・サイト・アプリ上での行動に関するデータ<br/>・閲覧ページに関するデータ<br/>・ユーザー識別子（cookie、端末識別子等。以下同じです。）<br/></span>
                </div>
                <span>・利用目的<br/></span>
                <div className='ml-6'>
                  <span>・当社：アクセス解析<br/>・送信先：利用者による閲覧の傾向や履歴の分析<br/></span>
                </div>
                <span>・オプトアウト<br/></span>
                <div className='ml-6'>
                  <span>・</span><a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#0099d6]">https://tools.google.com/dlpage/gaoptout</a>
                </div>
              </div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">2025年8月4日 制定</div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default ExternalTransmissionPolicyPage;